import React from 'react';
import { Copy, UserCircle2 } from 'lucide-react';
import type { PlatformModule } from '@doer/frontend-components/platform-header';
import { dimensions } from '@doer/frontend-components/theme';

/**
 * Full catalog of available platform modules.
 * Use getClientModules() from client-config.ts to filter per client.
 */
export const PLATFORM_MODULES: PlatformModule[] = [
  {
    id: 'asset-multiplier',
    label: 'Asset multiplier',
    icon: <Copy size={dimensions.size.iconXl} />,
    path: '/',
  },
  {
    id: 'digital-brand-ambassador',
    label: 'Digital Brand Ambassador',
    icon: <UserCircle2 size={dimensions.size.iconXl} />,
    path: '/avatar-video',
  },
];
